export const computeOwnerURL = ({ value }) => {
    const keyword = value;
    return ["cars", "no-of-owners", keyword];
};
